const { getElement } = window.BAO.Utils
class SearchForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.setupListeners()
    this.modalElement = this.externalEls.QuickBuyModal
  }

  setupListeners () {
    this.handleSearchInput = this.handleSearchInput.bind(this)
    this.handleBodyClick = this.handleBodyClick.bind(this)
    this.handleAddToCartClick = this.handleAddToCartClick.bind(this)

    this.listeners.add(this.els.input.element, 'click', this.handleSearchInput)
    this.listeners.add(
      this.externalEls.trigger.element,
      'click',
      this.handleSearchInput,
    )

    document.body.addEventListener('click', this.handleBodyClick)
    document.addEventListener('quickBuy:added', this.handleAddToCartClick)
  }

  handleSearchInput (event) {
    event.stopPropagation()
    document.body.classList.add('util-SiteOverflowed', 'util-Search-open')
    const topPosition = window.scrollY
    document.body.style.setProperty('--SearchOverlayTop', `${topPosition}px`)
    this.els.input.element.focus()
  }

  handleAddToCartClick (event) {
    const searchResultsContainer = document.querySelector(
      '.kuQuickSearchResultsContainer',
    )
    if (!searchResultsContainer) return

    this.closeSearch()
    searchResultsContainer.style.cssText = 'display: none !important'
  }

  handleBodyClick (event) {
    this.modalElement = getElement(this.externalEls.QuickBuyModal.selector)

    if (
      !event.target.closest('.qb-Modal') &&
      !event.target.closest('.klevuWrap') &&
      !this.els.input.elements.includes(event.target)
    ) {
      this.closeSearch()
    }
  }

  closeSearch () {
    const searchResultsContainer = document.querySelector(
      '.kuQuickSearchResultsContainer',
    )
    if (!searchResultsContainer) return

    if (!document.body.classList.contains('util-Search-open')) return

    document.body.classList.remove('util-SiteOverflowed', 'util-Search-open')
    searchResultsContainer.style.cssText = 'display: none !important'
  }
}

if (!customElements.get('search-form')) {
  customElements.define('search-form', SearchForm)
}
